let quiet = false

/**
 * Moves focus without what a person's own focus brings, such as a tooltip
 * opening: for the focus a dialog moves in when it opens and gives back when
 * it closes. Focus events fire during `focus()`, so handlers can ask
 * `isQuietFocus()` while they run.
 */
export function focusQuietly(element: HTMLElement, options?: FocusOptions) {
  quiet = true
  try {
    element.focus(options)
  } finally {
    quiet = false
  }
}

/** Whether the focus being handled now was moved by `focusQuietly`. */
export function isQuietFocus() {
  return quiet
}
